/**
 * Forward mouse wheel to the document when the pointer is over fixed chrome
 * (sidebar, header) that is not itself scrollable — fixes pages where only
 * the scrollbar / arrow keys worked.
 *
 * Only runs over `position: fixed` layers to avoid double-scrolling normal content.
 */
function findScrollableParent(node) {
  let el = node instanceof Node ? node : null;
  while (el && el !== document.documentElement) {
    const { overflowY } = window.getComputedStyle(el);
    if (
      (overflowY === "auto" || overflowY === "scroll" || overflowY === "overlay") &&
      el.scrollHeight > el.clientHeight + 1
    ) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

function isWithinFixedLayer(node) {
  let el = node instanceof Node ? node : null;
  while (el && el !== document.documentElement) {
    if (window.getComputedStyle(el).position === "fixed") {
      return true;
    }
    el = el.parentElement;
  }
  return false;
}

export function initWheelScrollFix() {
  if (typeof window === "undefined") return;

  window.addEventListener(
    "wheel",
    (event) => {
      if (event.ctrlKey) return;
      if (!isWithinFixedLayer(event.target)) return;

      const doc = document.scrollingElement;
      if (!doc || doc.scrollHeight <= doc.clientHeight + 1) return;

      const scrollable = findScrollableParent(event.target);
      if (scrollable) {
        const { deltaY } = event;
        const atTop = scrollable.scrollTop <= 0;
        const atBottom =
          scrollable.scrollTop + scrollable.clientHeight >= scrollable.scrollHeight - 1;
        if ((deltaY < 0 && !atTop) || (deltaY > 0 && !atBottom)) {
          return;
        }
      }

      doc.scrollTop += event.deltaY;
      event.preventDefault();
    },
    { passive: false }
  );
}
